/*
 * KCTabs
 */
export function kcTabs() {
    let tabs = document.querySelectorAll('.kc-tabs__tab-link');
    let tab_contents = document.querySelectorAll('.kc-tabs__content');

    for ( let i = 0; i < tabs.length; i++ ) {
        tabs[i].addEventListener('click', function(e) {
            e.preventDefault();
            activateTab( tabs[i], tabs );
            activateTabContent( tabs[i].dataset.tab_id, tab_contents );
        });
    }
}

function activateTab( active_tab, tabs ) {
    // deactivate all tabs
    for ( let i = 0; i < tabs.length; i++ ) {
        tabs[i].classList.remove('is-active');
    }

    // activate this tab
    active_tab.classList.add('is-active');
}

function activateTabContent( tab_id, contents ) {
    for ( let i = 0; i < contents.length; i++ ) {
        if ( contents[i].dataset.tab_id == tab_id ) {
            contents[i].classList.add('is-active');
        }
        else {
            contents[i].classList.remove('is-active');
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/tabs.js